import { createAction, props } from '@ngrx/store';
import { CommissionSalespersonSchemeModel } from '@shared/data-access/models';

export const getDetail = createAction(
  '[SalesPerson Scheme] GET DETAIL',
  props<CommissionSalespersonSchemeModel>()
);
